@if (loaderIcon | async) {
  <app-loader></app-loader>
}
@if (openModal) {
  <div bsModal #syncModalRef="bs-modal" [config]="modalConfig" class="modal fade" id="syncModal" tabindex="-1" role="dialog" style="z-index: 99999 !important;">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" i18n="@@Confirm">Lock Info</h5>
          <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body ptb24">
          <div class="row justify-content-between">
            <div class="col-md-2">
              <div class="filter_radius me-1">
                <input type="text" class="form-control" [(ngModel)]="serialCode" [disabled]="true" placeholder="Serial Code">
              </div>
            </div>
            <div class="col-md-2 pl-0">
              <input type="text" class="form-control" [(ngModel)]="unlockCode" [disabled]="true" placeholder="Unlock Code">
            </div>
            <div class="col-md-2 pl-0">
              <input type="text" class="form-control" [(ngModel)]="lockStatus" [disabled]="true" placeholder="Lock Status">
            </div>
            <div class="col-md-2 pl-0">
              <select class="form-select" placeholder="Lien Stage" [(ngModel)]="lienStage">
                <option value="0" selected hidden>Select</option>
                @for (item of lienStagesList; track item) {
                  <option [value]="item.LateLienId" >{{item.LateLienName}}</option>
                }
              </select>
            </div>
            <div class="col-md-3 pl-4">
              <button type="button" class="btn btn-primary me-3" [disabled]="serialCode=='' || lienStage == '0' || (lienStagesList?.length <= (isNotification ? 0 : 1))" (click)="updateLienStage()">Update</button>
              <button type="button" class="btn btn-primary" data-backdrop="static" permissionHandler [functId]="471" [action]="eNumActionTypes.EDIT" [elementType]="eNumElementTypes.BUTTON" (click)="syncUnitCode()">Sync Code</button>
            </div>
          </div>
          <div class="row mx-0 mt-2">
            <table class="table mb-0 text-left table-hover table-striped">
              <colgroup>
              <col width="20%">
              <col width="20%">
              <col width="20%">
              <col width="20%">
            </colgroup>
            <thead>
              <tr>
                <th>Serial Code</th>
                <th>Unlock Code</th>
                <th>Lock Status</th>
                <th>Lien Stage</th>
              </tr>
            </thead>
            <tbody>
              @for (item of lockDetailsList; track item) {
                <tr style="height: 40px;" (click)="showSelectedRecord(item.SerialCode,item.LockStatus)">
                  <td>{{item.SerialCode}}</td>
                  <td>{{item.UnlockCode}}</td>
                  <td>{{item.LockStatus}}</td>
                  <td>{{item.LateLienName}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
}
